<template>
    <div v-loading="loading">
        <table class="table home-table">
            <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">Región</th>
                <th scope="col">Monto (CLP)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(d,i) in data" :key="i">
                <th scope="row">{{i + 1}}</th>
                <td>{{stateName(d.region)}}</td>
                <td>{{moneyFormatter(d.sum)}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import axios from 'axios';
    import _ from 'lodash';
    import numeral from 'numeral';
    import moneyFormatter from '../../Methods/MoneyFormatter'

    export default {
        data: function(){
            return {
                loading: false,
                data: [],
                periodo: this.$store.state.defaultYear,
                states: []
            }
        },
        computed: {
            url: function(){
                return '/api/v1/data/pagos?group-by='+JSON.stringify(['region'])+'&where={"periodo":'+JSON.stringify(this.periodo)+'}'+'&order-by='+JSON.stringify(['sum','desc'])
            }
        },
        methods: {
            numeral: numeral,
            moneyFormatter: moneyFormatter,
            find: _.find,
            findSum: function(code){
                const r = _.find(this.data, {region: code});

                if(!r)
                    return 0;

                return r.sum;
            },
            get: _.get,
            refreshData: function(){
                this.loading = true;
                axios.get(this.url)
                    .then((response) => {
                        this.loading = false;
                        this.data = response.data.filter(d => {
                            return d.region !== null;
                        }).slice(0,4);

                    })
            },
            stateName: function(id){
                return _.get(_.find(this.states, {id: id}), 'nombre');
            }
        },
        mounted: function(){
            this.refreshData();

            axios.get('/api/v1/data/regiones?metric=id')
                .then(response => {
                    this.states = response.data;
                });
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/StatesTable.vue